import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import { buildAreaRows } from './exportHubData';
import TabPanoramica from '../components/exporthub/TabPanoramica';
import TabTerritorio from '../components/exporthub/TabTerritorio';
import TabExport from '../components/exporthub/TabExport';
import './exportHub.css';

const TABS = [
  { id: 'panoramica', label: 'Panoramica' },
  { id: 'territorio', label: 'Territorio & Priorità' },
  { id: 'export', label: 'Export' },
];

export default function ExportHubPage() {
  const [tab, setTab] = useState('panoramica');
  const [kpi, setKpi] = useState(null);
  const [timeline, setTimeline] = useState([]);
  const [province, setProvince] = useState({});
  const [obiettivi, setObiettivi] = useState([]);
  const [showToWork, setShowToWork] = useState(true);
  const [esito, setEsito] = useState('all');
  const [periodo, setPeriodo] = useState(14);
  const [selRegioni, setSelRegioni] = useState(new Set());
  const [selProvince, setSelProvince] = useState(new Set());

  const load = useCallback(async () => {
    const [k, t, p, o] = await Promise.allSettled([
      axios.get(`${API}/dashboard/kpi`),
      axios.get(`${API}/dashboard/timeline?periodo=${periodo}`),
      axios.get(`${API}/dashboard/province-geo`),
      axios.get(`${API}/obiettivi`),
    ]);
    if (k.status === 'fulfilled') setKpi(k.value.data);
    if (t.status === 'fulfilled') setTimeline(t.value.data || []);
    if (p.status === 'fulfilled') setProvince(p.value.data.province || {});
    if (o.status === 'fulfilled') setObiettivi(o.value.data || []);
  }, [periodo]);

  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, [load]);

  const { regioni, province: provRows } = buildAreaRows(province, { showToWork });

  return (
    <div className="xhub">
      <div className="xhub-tabs">
        {TABS.map((t) => (
          <button key={t.id} type="button"
            className={`xhub-tab${tab === t.id ? ' on' : ''}`}
            onClick={() => setTab(t.id)}>{t.label}</button>
        ))}
      </div>

      {tab === 'panoramica' && <TabPanoramica kpi={kpi} timeline={timeline} periodo={periodo} setPeriodo={setPeriodo} />}
      {tab === 'territorio' && (
        <TabTerritorio
          regioni={regioni} province={provRows} obiettivi={obiettivi}
          esito={esito} setEsito={setEsito}
          showToWork={showToWork} setShowToWork={setShowToWork}
          selRegioni={selRegioni} setSelRegioni={setSelRegioni}
          selProvince={selProvince} setSelProvince={setSelProvince}
          onReloadObiettivi={load}
          goExport={() => setTab('export')}
        />
      )}
      {tab === 'export' && (
        <TabExport initial={{ regioni: [...selRegioni], province: [...selProvince] }} />
      )}
    </div>
  );
}
